import loader from './loader.gif'
import './loader.css'

const ForegroundLoader = () => {
  return (
    <div className="foregroundloader-wrapper">
      <img
        className="foreground-loader"
        width="200"
        src={loader}
        alt="loader"
      />
    </div>
  )
}
export default ForegroundLoader
